import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Tag, Tooltip } from "antd";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { RootState } from "../../../app/store";
import { BankInterface } from "../../../interfaces/Bank.interface";

export default function TerminalBankFloors({ bank }: { bank: BankInterface }) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const columns = [
    {
      title: "Floor Name",
      dataIndex: "name",
      key: "name",
      render: (text: string) => <b>{text}</b>,
    },
    {
      title: "Floor Index",
      dataIndex: "floorIndex",
      key: "floorIndex",
    },
    {
      title: "Front Door",
      dataIndex: "frontDoor",
      key: "frontDoor",
      render: (open: boolean) =>
        open ? <Tag color="green">True</Tag> : <Tag color="red">False</Tag>,
    },
    {
      title: "Rear Door",
      dataIndex: "rearDoor",
      key: "rearDoor",
      render: (open: boolean) =>
        open ? <Tag color="green">True</Tag> : <Tag color="red">False</Tag>,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date: string) => <Tooltip title={date}>{new Date(date).toLocaleString()}</Tooltip>,
    },
  ];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div
      className={`monitoring__card__${theme} generalStyles__width100`}
      style={{ height: "auto", marginTop: "20px" }}
    >
      {bank && bank.bankFloors && bank.bankFloors.length > 0 && (
        <Table
          columns={columns}
          dataSource={[...bank.bankFloors].sort((a, b) => b.floorIndex - a.floorIndex)}
          rowKey="id"
          pagination={false}
          bordered
          size="small"
        />
      )}
    </div>
  );
}
